import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_SHIPPING_ZONE_LISTING,
    ADD_SHIPPING_ZONE,
    UPDATE_SHIPPING_ZONE,
    DELETE_SHIPPING_ZONE,
    EXPORT_SHIPPING_ZONE,
    GET_SHIPPING_ZONE_DETAILS,
    UPDATE_SHIPPING_ZONE_ACTIVATION,
} from "./actionTypes.js";

import {
    getShippingZoneListingSuccess,
    getShippingZoneListingFail,
    getShippingZoneDetailsSuccess,
    createShippingZoneSuccess,
    createShippingZoneFail,
    updateShippingZoneSuccess,
    updateShippingZoneFail,
    deleteShippingZoneSuccess,
    deleteShippingZoneFail,
    exportShippingZoneSuccess,
    exportShippingZoneFail,
    getShippingZoneDetailsFail,
    updateShippingZoneActivationSuccess,
    updateShippingZoneActivationFail,
} from "./actions.js";

import {
    shippingZoneListingApi,
    shippingZoneDetailsApi,
    addShippingZoneApi,
    updateShippingZoneApi,
    deleteShippingZoneApi,
    exportShippingZoneApi,
    updateShippingZoneActivationApi,
} from "./shippingZoneApi.js";

function* fetchShippingZoneListing({ payload }) {
    try {
        const response = yield call(shippingZoneListingApi, payload);
        yield put(getShippingZoneListingSuccess(response));
    } catch (error) {
        yield put(getShippingZoneListingFail(error));
    }
}

function* fetchShippingZoneDetail({ payload }) {
    try {
        const response = yield call(shippingZoneDetailsApi, payload);
        yield put(getShippingZoneDetailsSuccess(response));
    } catch (error) {
        yield put(getShippingZoneDetailsFail(error));
    }
}

function* createShippingZone({ payload }) {
    try {
        const response = yield call(addShippingZoneApi, payload);
        yield put(createShippingZoneSuccess(response));
    } catch (error) {
        yield put(createShippingZoneFail(error));
    }
}

function* updateShippingZone({ payload }) {
    try {
        const response = yield call(updateShippingZoneApi, payload);
        yield put(updateShippingZoneSuccess(response));
    } catch (error) {
        yield put(updateShippingZoneFail(error));
    }
}

function* updateShippingZoneActivation({ payload }) {
    try {
        const response = yield call(updateShippingZoneActivationApi, payload);
        yield put(updateShippingZoneActivationSuccess(response));
    } catch (error) {
        yield put(updateShippingZoneActivationFail(error));
    }
}

function* deleteShippingZone({ payload }) {
    try {
        const response = yield call(deleteShippingZoneApi, payload);
        yield put(deleteShippingZoneSuccess(response));
    } catch (error) {
        yield put(deleteShippingZoneFail(error));
    }
}

function* exportShippingZone({ payload }) {
    try {
        const response = yield call(exportShippingZoneApi, payload);
        yield put(exportShippingZoneSuccess(response));
    } catch (error) {
        yield put(exportShippingZoneFail(error));
    }
}

function* ShippingZoneSaga() {
    yield takeEvery(GET_SHIPPING_ZONE_LISTING, fetchShippingZoneListing);
    yield takeEvery(GET_SHIPPING_ZONE_DETAILS, fetchShippingZoneDetail);
    yield takeEvery(ADD_SHIPPING_ZONE, createShippingZone);
    yield takeEvery(UPDATE_SHIPPING_ZONE, updateShippingZone);
    yield takeEvery(UPDATE_SHIPPING_ZONE_ACTIVATION, updateShippingZoneActivation);
    yield takeEvery(DELETE_SHIPPING_ZONE, deleteShippingZone);
    yield takeEvery(EXPORT_SHIPPING_ZONE, exportShippingZone);

}

export default ShippingZoneSaga
